import React from "react";
import { Award, Euro, Sparkles, Zap } from "lucide-react";
import { usps } from "../mock";

const icons = {
  0: Award,
  1: Euro,
  2: Sparkles,
  3: Zap,
};

const USPBar = () => {
  return (
    <section className="border-y border-slate-200 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {usps.map((u, i) => {
            const Icon = icons[i] || Award;
            return (
              <div key={u.title} className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-yellow-400/90 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-slate-900" />
                </div>
                <div>
                  <div className="font-semibold text-slate-900 text-sm">{u.title}</div>
                  <div className="text-xs text-slate-600 leading-relaxed">{u.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default USPBar;
